import { TenantHierarchyDTO } from 'probonio-shared-ui/api';

export function findTenantInHierarchy(root: TenantHierarchyDTO, id: string): TenantHierarchyDTO | undefined {
  if (root.tenant.id === id) return root;
  for (const child of root.children ?? []) {
    const found = findTenantInHierarchy(child, id);
    if (found) return found;
  }
}

export function flattenTenants(root: TenantHierarchyDTO): TenantHierarchyDTO[] {
  return [root, ...(root.children ?? []).flatMap(flattenTenants)];
}
